// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';
import { brokeredPreviewStorage } from './previewAuthStorage';

const SUPABASE_URL = import.meta.env.VITE_SUPABASE_URL ?? "https://zkybcsbiwszwwevjvuto.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = import.meta.env.VITE_SUPABASE_ANON_KEY ?? import.meta.env.VITE_SUPABASE_PUBLISHABLE_KEY ?? "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InpreWJjc2Jpd3N6d3dldmp2dXRvIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NTczNjA1MDAsImV4cCI6MjA3MjkzNjUwMH0.cT0LbcoNjgOLdhH01Z84xF2mwn9vL8zFW4zGHDB0_58";

// Password recovery is consumed explicitly by AuthReset. Letting supabase-js
// auto-detect this route races the lazy-loaded page for the same one-use token.
export const shouldDetectSessionInUrl = (pathname: string) => pathname !== '/auth/reset';

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY, {
  auth: {
    storage: brokeredPreviewStorage(),
    persistSession: true,
    autoRefreshToken: true,
    detectSessionInUrl: shouldDetectSessionInUrl(
      typeof window === 'undefined' ? '' : window.location.pathname,
    ),
  }
});
